import { createSelector, createSlice } from '@reduxjs/toolkit';
export const initialInlineFormState = {
    activeInlineFormType: null,
};
export const inlineFormSlice = createSlice({
    name: 'inlineForm',
    initialState: initialInlineFormState,
    reducers: {
        changeForm: (state, actions) => {
            state.activeInlineFormType = actions.payload;
        },
    },
});
export const inlineFormActions = inlineFormSlice.actions;
const loginRegistrationInlineFormState = (state) => state.wrappers.inlineForm;
export const activeInlineFormTypeSelector = createSelector(loginRegistrationInlineFormState, ({ activeInlineFormType }) => activeInlineFormType);
export const isInlineFormTypeVisible = (formType) => createSelector(loginRegistrationInlineFormState, ({ activeInlineFormType }) => {
    return activeInlineFormType === formType;
});
export default inlineFormSlice.reducer;
//# sourceMappingURL=inlineFormSlice.js.map